// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"7d5bd971","599":"98c43c1b","643":"992d222d","830":"be7abf4f","860":"1f961811","971":"7b2a2514"}[chunkId] + ".css";
};